import { Component } from '@angular/core';
import { UserService } from './pages/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'HaykoProjet1';


  username: string;
  constructor(public tokenStorageService: UserService) { }


  ngOnInit(): void {
    
   
  }

  logout(): void {
    this.tokenStorageService.signOut();
  
  }
}
